import { render, staticRenderFns } from "./MapFilterTag.vue?vue&type=template&id=0b813300&scoped=true&"
import script from "./MapFilterTag.vue?vue&type=script&lang=ts&"
export * from "./MapFilterTag.vue?vue&type=script&lang=ts&"
import style0 from "./MapFilterTag.vue?vue&type=style&index=0&id=0b813300&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b813300",
  null
  
)

export default component.exports